import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "workspaces-24", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "currentColor", strokeWidth: 1.5 },
        React.createElement("g", { strokeLinejoin: "round" },
            React.createElement("path", { d: "m12 2.5 8.25 4.71v9.575L12 21.5l-8.25-4.715V7.209z" }),
            React.createElement("path", { d: "m12.002 7.1 4.253 2.45v4.9l-4.253 2.45-4.252-2.45v-4.9z" })),
        React.createElement("path", { d: "m12 2.5.002 4.6M12 16.9v4.6M3.75 7.209l4 2.341m8.505 4.9 3.995 2.335m0-9.576L16.255 9.55m-8.505 4.9-4 2.335" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
